module.exports = (function store() {
  'use strict';

  function nope() { /* Fallback for when no store is supported */ }

  try {
    sessionStorage.setItem('foo', 'bar');
    if (sessionStorage.getItem('foo') !== 'bar') throw 1;
  } catch (e) {
    var storage = require('window.name')
      , koekje = require('koekje');

    return storage.supported ? storage : (koekje.supported ? koekje : {
      length: 0,
      getItem: nope, setItem: nope, removeItem: nope, clear: nope
    });
  }

  return sessionStorage;
}());



//////////////////
// WEBPACK FOOTER
// ./~/sessionstorage/index.js
// module id = 220
// module chunks = 1